function timelineBlockDirective($window) {
	var vm = {};

	vm.restrict = 'A';
	vm.link = function(scope, elem, attr) {
		
		var mult  = 0.9;
		
		if (elem.offset().top > $window.innerHeight * mult + $window.pageYOffset) {
			elem.find('.cd-timeline-img, .cd-timeline-content').addClass('is-hidden');
		}

		angular.element($window).bind("scroll", function() {
			if (elem.offset().top <= $window.pageYOffset + $window.innerHeight && elem.find('.cd-timeline-img').hasClass('is-hidden')) {
				elem.find('.cd-timeline-img, .cd-timeline-content').removeClass('is-hidden').addClass('bounce-in');
			}
		});
	}

	return vm;
};

module.directive('timelineBlock', [ '$window', timelineBlockDirective ]);